import React, { useState, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { WizardPageTemplate } from 'gw-portals-wizard-components-ui';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { FNOLLossLocation, fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { DateUtil } from '@xengage/gw-portals-util-js';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { ClaimUtil } from 'gwce-capability-fnol-common-react-ext';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import messages from '../../../FNOLPA.messages';
import metadata from './GlassDetailsPage.metadata.json5';
import './GlassDetailsPage.messages';
import wizardConfig from '../../../config/fnol-pa-wizard-config.json5';

function FNOLPAGlassDetailsPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        changeNextSteps,
        currentStepIndex,
        history: {
            location: { state = {} }
        }
    } = props;
    const { steps: wizardSteps } = wizardConfig;
    const { capabilitiesConfig } = appConfig;
    const translator = useTranslator();
    const [isVehicleInvolve, setVehicleInvolve] = useState('');
    const {
        onValidate,
        isComponentValid,
        initialValidation,
        registerInitialComponentValidation,
        registerComponentValidation
    } = useValidation('GlassDetailsPage');

    const [availableYears, updateAvailableYears] = useState([]);
    const newVehicle = {
        placeholder: true
    };

    const LOB_NAME = ClaimUtil.getLobByPolicyType(_.get(claimVM, 'value.policy.policyType', 'personalAuto'));

    useEffect(() => {
        let nextSteps = wizardSteps.slice(currentStepIndex + 2, wizardSteps.length);
        if (!isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'vendor' })) {
            nextSteps = nextSteps.filter((step) => step.path !== '/type-of-repair');
        }
        changeNextSteps(nextSteps);
        if (_.isEmpty(_.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.value`))) {
            if (_.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.length`) === 0) {
                const value = _.get(claimVM, `lobs.${LOB_NAME}.value`, { createVehicleIncident: _.noop });
                value.createVehicleIncident();
            }
        }
        const currentYear = DateUtil.currentDate().getUTCFullYear();
        const years = [];
        const { oldestCarYear } = appConfig.personalAutoConfig;
        for (let i = currentYear; i >= oldestCarYear; i -= 1) {
            years.push({
                code: i,
                name: i
            });
        }
        updateAvailableYears(years);
        const theftCodes = {
            theftentire: _.find(claimVM.lossCause.aspects.availableValues, {
                code: 'theftentire'
            }),
            theftparts: _.find(claimVM.lossCause.aspects.availableValues, {
                code: 'theftparts'
            })
        };
        _.set(
            claimVM.value,
            `lobs.${LOB_NAME}.vehicleIncidents.theft`,
            _.values(theftCodes).includes(claimVM.lossCause.value)
        );
        _.set(claimVM.value, `lobs.${LOB_NAME}.vehicleIncidents.safeToDrive`, false);
        updateWizardData(claimVM);
        // Call once when page is mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAvalailableVehicles = useCallback(() => {
        const selectedVehicle = _.get(
            claimVM,
            `lobs.${LOB_NAME}.vehicleIncidents.value[0].vehicle`
        );
        if (!_.isEmpty(_.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.value[0]`))) {
            const vehicleIncidents = _.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.value[0]`, { availableVehicles: _.noop });
            const updatedAvailableVehicles = vehicleIncidents.availableVehicles(
                    _.get(claimVM, `lobs.${LOB_NAME}.value`),
                    selectedVehicle
                );
            updatedAvailableVehicles.push(newVehicle);

            // if there is a new vehicle added pass it in to list of available vehicles
            if (
                !_.isEmpty(_.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.value`))
                && !updatedAvailableVehicles.includes(
                    _.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.value`)
                )
            ) {
                updatedAvailableVehicles.push(
                    _.get(claimVM, `lobs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.value`)
                );
            }

            const updatedVehicleArray = updatedAvailableVehicles.map((value) => {
                const val = value.placeholder
                    ? translator(messages.paVehicleOtherVehicle)
                    : value.getDisplayName(translator(messages.paVehicleNewVehicle));
                return {
                    code: val,
                    name: val
                };
            });
            return updatedVehicleArray;
        }
        return [];
    }, [LOB_NAME, claimVM, newVehicle, translator]);

    const handleVehicleSelect = useCallback(
        (value) => {
            if (value === translator(messages.paVehicleOtherVehicle)) {
                const vehicleIncidentPath = `lobs.${LOB_NAME}.vehicleIncidents.value[0]`;
                const vehicleIncident = _.get(claimVM, vehicleIncidentPath);
                vehicleIncident.setNewVehicle(claimVM.value);
                setVehicleInvolve(translator(messages.paVehicleNewVehicle));
                updateWizardData(claimVM);
            } else {
                const vehiclesItems = _.get(claimVM, `lobs.${LOB_NAME}.vehicles.value`, []);
                const selectedVehicle = vehiclesItems.find((vehicle) => {
                    const displayName = vehicle.getDisplayName();
                    return displayName === value;
                });
                if (!_.isEmpty(selectedVehicle)) {
                    _.set(
                        claimVM,
                        `lobs.${LOB_NAME}.vehicleIncidents.value[0].vehicle`,
                        selectedVehicle
                    );
                    setVehicleInvolve(selectedVehicle.getDisplayName());
                }
                updateWizardData(claimVM);
            }
        },
        [claimVM, translator, updateWizardData, setVehicleInvolve, LOB_NAME]
    );

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showOptional: true,
            phoneWide: {
                labelPosition: 'top'
            }
        },
        vehicleDamaged: {
            availableValues: getAvalailableVehicles(),
            value: isVehicleInvolve,
            showOptional: false
        },
        lossLocationComponent: {
            path: !_.isUndefined(claimVM) ? claimVM : null,
            updatePath: updateWizardData
        },
        paVehicleOtherVehicleSection: {
            visible:
                !_.isEmpty(
                    _.get(claimVM, `obs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.value`)
                )
                && !_.get(
                    claimVM,
                    `lobs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.policyVehicle.value`
                )
        },
        paVehicleOtherVehicleYear: {
            availableValues: availableYears,
            value: _.get(
                claimVM,
                `lobs.${LOB_NAME}.vehicleIncidents.children[0].vehicle.year.value`
            )
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM, overrideProps]
    );

    const resolvers = {
        resolveCallbackMap: {
            handleVehicleSelect: handleVehicleSelect,
            onValidate: onValidate
        },
        resolveComponentMap: {
            losslocationcomponent: FNOLLossLocation
        }
    };

    const isClaimStatus = useCallback(() => {
        const { claimStatus } = state;
        const lossCauseCheck = _.get(claimVM.value, 'lossCause');
        return !_.isEmpty(claimStatus) && lossCauseCheck === 'glassbreakage';
    }, [claimVM, state]);

    const validateVehicleInvolve = useCallback(() => {
        return !_.isEmpty(
            _.find(
                _.get(claimVM, `lobs.${LOB_NAME}.value.vehicleIncidents`),
                (vehicleIncident) => vehicleIncident.vehicle !== null
            )
        );
    }, [claimVM, LOB_NAME]);

    useEffect(() => {
        registerInitialComponentValidation(isClaimStatus);
        registerComponentValidation(validateVehicleInvolve);
    }, [
        registerComponentValidation,
        validateVehicleInvolve,
        registerInitialComponentValidation,
        isClaimStatus
    ]);

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                resolveValue={readValue}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

FNOLPAGlassDetailsPage.propTypes = wizardProps;
export default withRouter(FNOLPAGlassDetailsPage);
